import { memo } from "react";
import { Link } from "react-router-dom";
import CircleXDarkIcon from "components/icons/linear/circle-x-dark.svg?react";
import { IGlobalNotification } from "services/types";
import "./InfoBar.scss";

interface IInfoBar {
  onLinkAction: (id: string) => void;
  onCloseInfoBar: (id: string) => void;
  notification: IGlobalNotification;
  showNotify: boolean;
}

export const InfoBar: React.FC<IInfoBar> = memo(({
  onLinkAction,
  onCloseInfoBar,
  notification,
  showNotify
}) => {
  const onLinkClick = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const href = (e.target as HTMLAnchorElement).href ;
    await onLinkAction(notification.id);
    location.href = href;
  };

  const onClose = () => {
    onCloseInfoBar(notification.id);
  };

  return (
    <div className={`InfoBar ${!showNotify ? "InfoBar_isHidden" : ""}`}>
      <div className="InfoBar-Wrap">
        <p className="InfoBar-Text">
          {notification.text} <Link rel="info-bar" onClick={onLinkClick} to={notification.cta_link}>{notification.cta_text}</Link>
        </p>
        <button className="InfoBar-CloseBtn" onClick={onClose} aria-label="Close Information Bar">
          <CircleXDarkIcon />
        </button>
      </div>
    </div>
  );
});
